// extracted by mini-css-extract-plugin
module.exports = {"topSlide":"heroslide-module--topSlide--15JBW"};